import React from "react"
import { EntryPillSelector } from "@ciq/shared/components/modal"
import { FilterQueryArgs, useFilterQueryParams } from "../../hooks/filter_query_params"
import { ZoneType } from "@ciq/shared/utils/const"
import { useAnalyticsContext } from "../../../../contexts/AnalyticsContext"

/**
 * View toggle component for switching between Building View and End Zone View.
 * Positioned in the top-right corner of the map overlay.
 *
 * @returns {React.ReactElement} View toggle component
 */
export function ViewToggle() {
  const { zoneType, setFilters } = useFilterQueryParams()
  const { map } = useAnalyticsContext()

  const viewTypeData = {
    values: [
      {
        selected: zoneType === ZoneType.BUILDING,
        label: "Building View",
        value: ZoneType.BUILDING,
      },
      {
        selected: zoneType === ZoneType.DEFAULT,
        label: "End Zone View",
        value: ZoneType.DEFAULT,
      },
    ],
    onChange: newZoneType => {
      setFilters({ [FilterQueryArgs.ZONE_TYPE]: newZoneType.value })
      map.trackViewChanged({
        view_type: newZoneType.value === ZoneType.BUILDING ? "building" : "end_zone",
      })
    },
  }

  return <EntryPillSelector className="map-view-toggle" {...viewTypeData} />
}
